var React = require('react');

function Botanical (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m146.65 317 19.54-22.77 74.81 64.22v-54.94l-94.35-80.99 19.54-22.76 74.81 64.21v-59.38l-52.31-44.9 19.54-22.77 32.77 28.13v-165.05l-126.64 159.43c-27.75 33.14-43.03 75.21-43.03 118.49 0 96.77 74.83 176.4 169.67 184.05v-63.99z","key":0}),React.createElement("path",{"d":"m397.64 159.43-126.64-159.43v165.05l32.77-28.13 19.54 22.77-52.31 44.9v59.38l74.81-64.21 19.54 22.76-94.35 80.99v54.94l74.81-64.22 19.54 22.77-94.35 80.98v63.99c94.84-7.65 169.67-87.28 169.67-184.05 0-43.28-15.28-85.35-43.03-118.49z","key":1}),React.createElement("path",{"d":"m241 461.97v50.03h30v-50.03c-4.95.41-9.95.61-15 .61s-10.05-.2-15-.61z","key":2})]);
}

Botanical.defaultProps = {"id":"Capa_1","enableBackground":"new 0 0 512 512","height":"512","viewBox":"0 0 512 512","width":"512"};

module.exports = Botanical;

Botanical.default = Botanical;
